var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckoutBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56259 4.72482H11.2498C11.4488 4.72482 11.6395 4.80384 11.7802 4.94449C11.9208 5.08514 11.9998 5.27591 11.9998 5.47482C11.9998 5.67374 11.9208 5.8645 11.7802 6.00515C11.6395 6.1458 11.4488 6.22482 11.2498 6.22482H2.56259L6.00584 9.66807C6.14667 9.8088 6.22583 9.99971 6.2259 10.1988C6.22597 10.3979 6.14695 10.5889 6.00622 10.7297C5.86548 10.8705 5.67457 10.9497 5.47548 10.9498C5.27639 10.9498 5.08542 10.8708 4.94459 10.7301L0.21959 6.00507C0.0789866 5.86443 0 5.6737 0 5.47482C0 5.27595 0.0789866 5.08522 0.21959 4.94457L4.94459 0.219573C5.08552 0.0788421 5.27658 -0.000140465 5.47575 1.87534e-07C5.67491 0.00014084 5.86586 0.0793932 6.00659 0.220323C6.14732 0.361252 6.2263 0.552314 6.22616 0.751478C6.22602 0.950642 6.14677 1.14159 6.00584 1.28232L2.56259 4.72482Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutBackArrow);
export default __webpack_public_path__ + "static/media/checkout-back-arrow.a022e53e12dd6d400c498b39e84ce268.svg";
export { ForwardRef as ReactComponent };